import FieldLabel from 'components/styledInput/FieldLabel';
import StyledInput from 'components/styledInput/StyledInput';

/**
 * A job description name: the qualification prefix, which cannot be edited,
 * in a grey box, followed by the field where only the rest is typed.
 */
const TemplateNameField = ({
  label,
  prefix,
  value,
  onChange,
  placeholder,
  isDisabled,
  error,
  inputRef,
}) => (
  <div className="flex flex-col gap-1.5">
    <FieldLabel label={label} />
    {/* Bottom-aligned: the field's screen-reader label still takes the
        label row's gap above the input, the prefix box does not. The two read
        as one field: no gap, no radius nor double border where they meet. */}
    <div className="flex items-end">
      {prefix ? (
        <span
          className="shrink-0 max-w-[55%] h-10 px-3 flex items-center rounded-l-[0.4rem] border border-r-0 border-gray-200 bg-gray-100 text-sm text-gray-800"
          title={prefix}
        >
          <span className="truncate">{prefix}</span>
        </span>
      ) : null}
      <div className={`flex-1 min-w-0 ${prefix ? '[&_input]:rounded-l-none' : ''}`}>
        <StyledInput
          type="text"
          label={<span className="sr-only">{label}</span>}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          isDisabled={isDisabled}
          inputRef={inputRef}
        />
      </div>
    </div>
    {error ? <span className="ft-sm text-red-500">{error}</span> : null}
  </div>
);

export default TemplateNameField;
